import React from 'react';
import Grid from '@components/core/layout/Grid';
import Link from 'next/link';
import Icon from '@components/core/Icon';
import { getInternalPath } from '@helpers/internalLink';

export default function ThreeXCtaSection(props) {
  const ctas = [ props.cta1, props.cta2, props.cta3 ];

  return (
    <Grid>
      <div className='col-span-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8'>
        {ctas.map((cta, index) => (
          <div key={ index }>
            <Link
              href={
                cta.link.externalUrl ?? getInternalPath(cta.link.internalLink)
              }
            >
              <div className='group cursor-pointer relative hover:scale-105 transition-all duration-300'>
                {/* White card content */}
                <div
                  className={ sq`
                    ${ props.sectionBackgroundColor ? 'bg-white' : 'bg-primary-50' }
                    rounded-2xl
                    px-6
                    py-8
                    text-center
                    hover:shadow-2xl
                    transition-all
                    duration-300
                    cursor-pointer
                    min-h-[140px]
                    flex
                    flex-col
                    justify-center
                    items-center
                    gap-5
                    shadow-lg
                    group
                    relative
                    overflow-hidden
                    -mb-2
                  ` }
                >
                  <div className='text-heading-xs md:text-heading-sm text-primary-800'>
                    {cta.kop}
                  </div>
                  <div className='text-body-md md:text-body-lg text-primary-800'>
                    {cta.tekst}
                  </div>

                  {/* Pink circular button with white arrow */}
                  <div className='w-10 h-10 bg-cta-500 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-md'>
                    <Icon
                      name='ArrowForward'
                      className='w-4 h-4 text-white'
                    />
                  </div>
                </div>

                {/* Domain bar background - bottom */}
                <div className={ sq`
                  ${ index === 1 ? 'bg-gradient-to-l' : 'bg-gradient-to-r' } from-primary-300 to-primary-600 rounded-b-2xl h-4
                ` }></div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </Grid>
  );
}
